import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
  AchModule,
  AureusFormsModule,
  ButtonModule,
  CreditCardModule,
} from '@arc/aureus';
import { I18nModule } from '@arc/unified-payments-frontend/i18n';
import { CheckboxModule } from 'primeng/checkbox';
import { SelectButtonModule } from 'primeng/selectbutton';
import { PaymentMethodFormComponent } from './components/payment-method-form/payment-method-form.component';

@NgModule({
  declarations: [PaymentMethodFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectButtonModule,
    AureusFormsModule,
    AchModule,
    CreditCardModule,
    CheckboxModule,
    ButtonModule,
    I18nModule,
  ],
  exports: [PaymentMethodFormComponent],
})
export class SharedPaymentAccountsModule {}
